export default __webpack_public_path__ + "static/media/home-decor-img-05.61014502.jpg";